import { useApiClient } from "../../../shared/customHooks";
import BaseComponent from "../../../shared/baseComponent/BaseComponent";
import { ProviderUsersForm } from "../../../shared/formObjects/provider/providerUsersForm";
import { useGlobalContext } from "../../../shared/GlobalContext";

function ManageUserComponent({ data }: any) {
  const api = useApiClient("UserLink", { identity: true });
  const {
    accountInfo: { isManager },
  } = useGlobalContext();
  return (
    <>
      {data != null && (
        <BaseComponent
          formBody={ProviderUsersForm}
          headerLabel="Authorised Representative User Details"
          showEdit={false}
          disabled={!isManager}
          editPath="userProviders"
          apiClient={api}
          data={data}
          showInternalNotes={false}
          id={data.userId}
          submitApiPath={"EditUser"}
        />
      )}
    </>
  );
}

export default ManageUserComponent;
